var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.statusObj)?_c('span',{staticClass:"badge",style:(`color: white;background-color:${_vm.statusObj.color}`)},[_vm._v(" "+_vm._s(_vm.statusObj.label)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }